import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationWithRangeInput } from '../../../../types/schema/utils.types';
import { Payment } from '../../../../types/schema/payment.types';

interface GetAllPaymentsByRangeByPageHook {
  data: Payment[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllPaymentsByRangeByPage: Payment[];
    }>
  >;
}

interface GetAllPaymentsByRangeByPageMutationData {
  getAllPaymentsByRangeByPage: Payment[];
}

interface GetAllPaymentsByRangeByPageInputType {
  input: PaginationWithRangeInput;
}

export function useGetAllPaymentsByRangeByPage(
  query: DocumentNode,
  input: PaginationWithRangeInput
): GetAllPaymentsByRangeByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllPaymentsByRangeByPageMutationData,
    GetAllPaymentsByRangeByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllPaymentsByRangeByPage,
    loading,
    error,
    refetch,
  };
}
